var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelegramWhite35X35 = function SvgTelegramWhite35X35(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 54896",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4355",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#2ca5e0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "telegram-alt-3",
    d: "M25.254 10.268a1.548 1.548 0 0 0-1.57-.245l-13.539 5.466a1.543 1.543 0 0 0 .079 2.885l2.739.952 1.526 5.049a.754.754 0 0 0 .089.191l.02.025a.747.747 0 0 0 .16.163.717.717 0 0 0 .053.038.745.745 0 0 0 .235.1H15.06a.772.772 0 0 0 .153.015h.014a.75.75 0 0 0 .227-.04c.017-.006.032-.016.048-.023a.75.75 0 0 0 .154-.087l.115-.1 2.041-2.254 3.045 2.359a1.529 1.529 0 0 0 .938.322 1.552 1.552 0 0 0 1.518-1.228l2.465-12.1a1.533 1.533 0 0 0-.524-1.489Zm-9.742 9.3a.751.751 0 0 0-.206.382l-.233 1.136-.592-1.96 3.071-1.6Zm6.277 4.006-3.6-2.787a.757.757 0 0 0-1.023.09l-.654.722.231-1.123 5.346-5.352a.755.755 0 0 0-.883-1.2l-7.68 4-2.811-1.035 13.583-5.433Z",
    fill: "#fff"
  })));
};
export default SvgTelegramWhite35X35;